import * as yup from 'yup';
import type { PnlQueryStats } from 'src/components/star-grid/queryStats.types';

const counter = yup.number().min(0).nullable();
const queryStatsSchema = yup.object({
  query_id: yup.string().required(),
  available: yup.boolean().required(),
  source_rows: counter.integer(),
  source_rows_display: yup.string().nullable(),
  source_table: yup.string().nullable(),
  scan_rows: counter.integer(),
  tablets_scanned: counter.integer(),
  bytes_read: counter.integer(),
  wall_time_ms: counter,
  cpu_time_ms: counter,
  peak_memory_bytes: counter.integer(),
  sql: yup.string().nullable()
});
export const parseQueryStats = (value: unknown): Promise<PnlQueryStats> => queryStatsSchema.validate(value, { strict: true });
